// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: util/common/lcmtypes/flight_phase_enum_t.lcm
import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmEnumMsg from "@skydio/lcm/src/enum";

enum option_t {
  UNKNOWN = 0,
  REST = 12,
  CONFIGURING = 22,
  PREP_CLEANUP = 19,
  PREP = 1,
  WAIT_FOR_ARM = 6,
  LOGGING_START = 17,
  PERCH = 21,
  FLIGHT_PROCESSES_CHECK = 14,
  SAFETY_CHECK = 15,
  PRE_FLIGHT_INSPECTION = 23,
  READY_FOR_HAND_TAKEOFF = 16,
  HAND_TAKEOFF_PREP = 8,
  FLYING = 4,
  TEGRA_REBOOT_PREP = 18,
  ARMED_IN_DOCK = 20,
  POST_FLIGHT = 13,
}

export class flight_phase_enum_t extends LcmEnumMsg {
  public static override option_t = option_t;
  private static _hash = Long.fromString("11999453122282051735", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (flight_phase_enum_t._packed_fingerprint === undefined) {
      flight_phase_enum_t._packed_fingerprint = flight_phase_enum_t._get_hash_recursive([]);
    }
    return flight_phase_enum_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(flight_phase_enum_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = flight_phase_enum_t._hash;
    tmp_hash = tmp_hash.shl(1).add(tmp_hash.shru(63));
    return tmp_hash;
  }

  public override decode(array: Uint8Array): flight_phase_enum_t {
    const decoder = new Decoder(
      new DataView(array.buffer, array.byteOffset, array.byteLength)
    );
    const hash = decoder.decode_hash();
    if (!hash.equals(flight_phase_enum_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, flight_phase_enum_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  // Recursively decode a message with the supplied decoder.
  public override decode_one(decoder: Decoder): flight_phase_enum_t {
    this.value = decoder.decode_int32_t();
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    return 4;
  }

  public override encode(): ArrayBufferLike {
    const total_size = this._get_encoded_size();
    const encoder = new Encoder(total_size);
    this.encode_one(encoder);
    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int32_t(this.value);
  }

  // static constructors
  static get UNKNOWN() {
    return new flight_phase_enum_t(option_t.UNKNOWN);
  }
  static get REST() {
    return new flight_phase_enum_t(option_t.REST);
  }
  static get CONFIGURING() {
    return new flight_phase_enum_t(option_t.CONFIGURING);
  }
  static get PREP_CLEANUP() {
    return new flight_phase_enum_t(option_t.PREP_CLEANUP);
  }
  static get PREP() {
    return new flight_phase_enum_t(option_t.PREP);
  }
  static get WAIT_FOR_ARM() {
    return new flight_phase_enum_t(option_t.WAIT_FOR_ARM);
  }
  static get LOGGING_START() {
    return new flight_phase_enum_t(option_t.LOGGING_START);
  }
  static get PERCH() {
    return new flight_phase_enum_t(option_t.PERCH);
  }
  static get FLIGHT_PROCESSES_CHECK() {
    return new flight_phase_enum_t(option_t.FLIGHT_PROCESSES_CHECK);
  }
  static get SAFETY_CHECK() {
    return new flight_phase_enum_t(option_t.SAFETY_CHECK);
  }
  static get PRE_FLIGHT_INSPECTION() {
    return new flight_phase_enum_t(option_t.PRE_FLIGHT_INSPECTION);
  }
  static get READY_FOR_HAND_TAKEOFF() {
    return new flight_phase_enum_t(option_t.READY_FOR_HAND_TAKEOFF);
  }
  static get HAND_TAKEOFF_PREP() {
    return new flight_phase_enum_t(option_t.HAND_TAKEOFF_PREP);
  }
  static get FLYING() {
    return new flight_phase_enum_t(option_t.FLYING);
  }
  static get TEGRA_REBOOT_PREP() {
    return new flight_phase_enum_t(option_t.TEGRA_REBOOT_PREP);
  }
  static get ARMED_IN_DOCK() {
    return new flight_phase_enum_t(option_t.ARMED_IN_DOCK);
  }
  static get POST_FLIGHT() {
    return new flight_phase_enum_t(option_t.POST_FLIGHT);
  }

  public override value: option_t;

  constructor(value?: option_t) {
    super();
    this.value = value ?? option_t.UNKNOWN;
  }

  public override get name(): string {
    return option_t[this.value]!;
  }
}